export const PromotionAndOfferCreationConst = {
    titleCharacterLimit: 20,
    subTitleCharacterLimit: 70,
    minimumLength:0,
};